const SCRIPT_LOAD_DELAY = 25;

const waitForScriptToLoad = callback => {
  return () => {
    if (window.FingerprintJS === undefined) {
      setTimeout(() => {
        waitForScriptToLoad(callback);
      }, SCRIPT_LOAD_DELAY);
    } else {
      callback();
    }
  };
};

const loadScript = () => {
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('dataservice-fp-script', '');
  scriptElement.setAttribute('async', '');
  scriptElement.src = 'https://dataservice-code.tmok.tm/fp.js';

  return new Promise((resolve, reject) => {
    scriptElement.addEventListener(
      'load',
      waitForScriptToLoad(() => {
        resolve(scriptElement);
      }),
      false,
    );

    scriptElement.onerror = error => {
      reject(error);
    };

    document.head.appendChild(scriptElement);
  });
};

export default {
  async load() {
    await loadScript();
    return window.FingerprintJS.load();
  },
};
